import { formatDate } from '../utils';

interface Props {
  startDate: string;
  endDate: string;
  onPrev: () => void;
  onNext: () => void;
  canNext: boolean;
}

export function Header({ startDate, endDate, onPrev, onNext, canNext }: Props) {
  return (
    <div class="hdr">
      <div class="hdr-title">WEEKLY // REVIEW</div>
      <div class="hdr-nav">
        <button onClick={onPrev} aria-label="Previous week">&#8592;</button>
        <span class="hdr-dates">
          {startDate && endDate ? `${formatDate(startDate)} -- ${formatDate(endDate)}` : '...'}
        </span>
        <button
          onClick={onNext}
          aria-label="Next week"
          style={{ opacity: canNext ? 1 : 0.2, pointerEvents: canNext ? 'auto' : 'none' }}
          disabled={!canNext}
        >
          &#8594;
        </button>
      </div>
    </div>
  );
}
